module.exports = __webpack_public_path__ + "img/bg03.93edc1b5.jpg";